import { get, set } from 'lodash'

function normalizeRefIds(items) {
  if (!Array.isArray(items)) return []
  return items.map((item) =>
    typeof item === 'object' && item !== null ? item.id || item.ref : item
  )
}

function coreBusinessesToFormValue(apiCoreBusinesses) {
  const arr = normalizeRefIds(apiCoreBusinesses)
  if (arr.length > 1) return ''
  return arr.length ? arr[0] : ''
}

export const REVETTING_PREPOPULATE_FIELD_PATHS = [
  'company.id',
  'company.name',
  'company.website',
  'company.core_businesses', //if more than one, the required field will force a reselction
  'company.target_population',
  'company.programmes_and_services',
  'company.distribution_channel',
  'company.additionalComments',
  'company.addresses',
  'company.contacts',
]

export function beneficiaryToRevettingFormValues(beneficiary) {
  if (!beneficiary) return null
  const company = get(beneficiary, 'company') || {}
  return {
    company: {
      id: get(company, 'id'),
      name: get(company, 'name', ''),
      website: get(company, 'website', ''),
      slug: get(company, 'slug', ''),
      core_businesses: coreBusinessesToFormValue(get(company, 'core_businesses')),
      target_population: normalizeRefIds(get(company, 'target_population')),
      programmes_and_services: get(company, 'programmes_and_services', '') || '',
      distribution_channel: normalizeRefIds(get(company, 'distribution_channel')),
      additionalComments: get(company, 'additionalComments', '') || '',
      addresses: get(company, 'addresses', []) || [],
      contacts: get(company, 'contacts', []) || []
    },
  }
}

export function getRevettingInitialValues(
  defaultValues,
  sourceValues,
  fieldPaths = REVETTING_PREPOPULATE_FIELD_PATHS
) {
  if (!sourceValues || !fieldPaths || fieldPaths.length === 0) {
    return defaultValues
  }
  const result = JSON.parse(JSON.stringify(defaultValues))
  for (const path of fieldPaths) {
    const value = get(sourceValues, path)
    if (value !== undefined) {
      set(result, path, value)
    }
  }
  return result
}
